import { Steps } from 'antd';

type MobileStepProps = {
  current: number;
};

const items = [
  {
    title: 'Хаяг',
  },
  {
    title: 'Илгээмж',
  },
  {
    title: 'Төлбөр',
  },
];

const MobileStep = ({ current }: MobileStepProps) => {
  return (
    <div style={{ paddingTop: 25 }}>
      <Steps
        responsive={false}
        className="ant-steps-horizontal ant-steps-label-vertical"
        direction="horizontal"
        size={'small'}
        progressDot
        current={current || 0}
        items={items}
      />
    </div>
  );
};

export default MobileStep;
